import { useCookies } from 'react-cookie';
import { jwtDecode } from 'jwt-decode';

const useAuthenticate = () => {
  const [cookies] = useCookies('token');
  const { token } = cookies ?? {};

  if (token && typeof token === 'string') {
    const accountInfo = jwtDecode(token) ?? {};
    let jwtExpTime = accountInfo?.exp;
    if (jwtExpTime * 1000 < new Date().getTime()) {
      return { auth: false };
    } else {
      return { auth: true, accountInfo };
    }
  }
  return { auth: false };
};

export default useAuthenticate;
